import { ApiSlugs, FileAdminDto, FileId, FileSummaryDto, ListPagination } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';
import { ApiConnector } from '../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../utils/query-params.utils';

export class FilesAdminConnector extends ApiConnector<FileAdminDto, FileAdminDto, FileId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.FILES);
  }

  summerized = () => ({
    list: (pagination?: ListPagination): Observable<FileSummaryDto[]> =>
      this.apiCaller.getRequest<FileSummaryDto[]>(this.apiPrefix, `${this.slug}/all`, {
        params: QueryParamsUtils.toParams(pagination),
      }),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(this.apiPrefix, `${this.slug}/all/count`, {
        params: QueryParamsUtils.toParams(pagination, true),
      }),
  });
}
